import React, { useEffect, useState } from "react";
import WAVES from "vanta/src/vanta.waves";

// ✅ fonction pour détecter si WebGL tourne en mode software
function isSoftwareRenderer() {
  const gl = document.createElement("canvas").getContext("webgl");
  if (!gl) return true;
  const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
  if (!debugInfo) return false;
  const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
  return /swiftshader/i.test(renderer);
}

function VantaWaves({ children }) {
  const [vantaEffect, setVantaEffect] = useState(null);
  const [fallback, setFallback] = useState(false);

  useEffect(() => {
    if (isSoftwareRenderer()) {
      // ⚠️ si pas d'accélération matérielle → fallback
      setFallback(true);
      return;
    }

    if (!vantaEffect) {
      const effect = WAVES({
        el: '#vanta',
        color: 0xE0A629,
        shininess: 22.00,
        gyroControls: false,
        waveHeight: 12.00,
        waveSpeed: 0.50,
        scale: 1.00,
        scaleMobile: 1.00,
        zoom: 1
      });
      setVantaEffect(effect);
    }

    return () => {
      if (vantaEffect) vantaEffect.destroy();
    };
  }, [vantaEffect]);

  if (fallback) {
    // ✅ Fallback simple : image statique
    return (
      <div
        id="vanta"
        className="bg"
        style={{
            backgroundImage: `
            linear-gradient(rgba(255, 225, 58, 0.85), rgba(255, 225, 58, 1)), 
            url('/images/vanta_fallback.png')
        `,
          backgroundBlendMode: "multiply",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {children}
      </div>
    );
  }

  return (
    <div className="bg" id="vanta">
      {children}
    </div>
  );
}

export default VantaWaves;
